import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  mobileView?: boolean;
}

const NotFoundGraphic = ({
  title,
  titleId,
  mobileView = false, // Hides the shadow on mobile view
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    viewBox={mobileView ? "0 0 985.23 298.63" : "0 0 985.23 598.63"}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {(title != null) ? <title id={titleId}>{title}</title> : null}
    { !mobileView
      && <path d="M453.89,598.63L.27,145.01,77.48,31.48,117.21,1.96l37.47,37.47,22.71-19.3,69.82-2.84,27.82,27.82,27.82,27.82,6.24-5.11L388.56,1.96,985.23,598.63H453.89Z" 
        style={{fill: "rgba(0, 29, 210, .09)"}}
      />
    }
    <path d="M138.3,146.35h-19.63v34.51h-47.57v-34.51H0v-35.37L74.15,2.56h44.52V110.38h19.63v35.98Zm-67.2-35.98v-20.73c0-1.87,.04-4.23,.12-7.07l.24-8.54c.16-2.93,.28-5.37,.37-7.32,.16-2.03,.28-3.13,.37-3.29h-1.34c-1.54,3.66-2.97,6.71-4.27,9.15-1.3,2.36-3.01,5.16-5.12,8.42l-19.76,29.39h29.39Zm197.2-18.42c0,14.31-1.14,27.12-3.42,38.42-2.28,11.22-5.94,20.77-10.98,28.66-4.96,7.89-11.55,13.9-19.76,18.05-8.21,4.15-18.29,6.22-30.25,6.22-14.88,0-27.08-3.62-36.59-10.85-9.51-7.32-16.55-17.77-21.1-31.35-4.47-13.66-6.71-30.04-6.71-49.15s2.03-35.73,6.1-49.39c4.15-13.74,10.94-24.27,20.37-31.59C175.41,3.66,188.05,0,203.91,0c14.88,0,27.04,3.66,36.47,10.98,9.51,7.24,16.55,17.73,21.1,31.47,4.55,13.66,6.83,30.17,6.83,49.52Zm-80.86,0c0,11.63,.41,21.38,1.22,29.27,.89,7.89,2.52,13.82,4.88,17.81,2.44,3.9,5.89,5.85,10.37,5.85s7.89-1.95,10.25-5.85c2.36-3.98,3.98-9.88,4.88-17.68,.89-7.89,1.34-17.68,1.34-29.39s-.45-21.63-1.34-29.51c-.89-7.89-2.52-13.82-4.88-17.81-2.36-4.07-5.77-6.1-10.25-6.1s-7.93,2.03-10.37,6.1c-2.36,3.98-3.98,9.92-4.88,17.81-.81,7.89-1.22,17.73-1.22,29.51Zm220.86,54.4h-19.64v34.51h-47.57v-34.51h-71.1v-35.37L344.15,2.56h44.52V110.38h19.64v35.98Zm-67.2-35.98v-20.73c0-1.87,.04-4.23,.12-7.07,.08-2.85,.16-5.69,.24-8.54,.16-2.93,.28-5.37,.37-7.32,.16-2.03,.29-3.13,.37-3.29h-1.34c-1.55,3.66-2.97,6.71-4.27,9.15-1.3,2.36-3.01,5.16-5.12,8.42l-19.76,29.39h29.39Z" 
      style={{fill: "#082ace"}}
    />
  </svg>
);

export default NotFoundGraphic;
